import type { ModerationResult } from '../types/moderation';
import { wait } from './wait';

const BLACKLIST = ['teste-bloqueio', 'reprovar', 'bloquear'];

/**
 * Moderação fake.
 * - Sempre aprova exceto se nome ou frase contiver alguma palavra da blacklist.
 * - Delay artificial 4.5-6s pra dar tempo do CeremonialLoader rodar as
 *   mensagens divertidas. Em V1 o tempo vem do provedor real.
 *
 * Útil pra demonstrar o fluxo de rejeição no pitch: digite "teste-bloqueio".
 */
export async function moderate(input: {
  displayName: string;
  message: string;
}): Promise<ModerationResult> {
  await wait(4500 + Math.random() * 1500);
  const haystack = `${input.displayName} ${input.message}`.toLowerCase();
  const hit = BLACKLIST.find((b) => haystack.includes(b));
  if (hit) {
    return {
      status: 'rejected',
      reason: `Encontramos um termo que não pode entrar na taça: "${hit}". Volte ao passo anterior e ajuste.`,
    };
  }
  return { status: 'approved' };
}
